// import Sidebar from "../SideBar/SideBar";
import Dashboard from "./Dashboard";

function MainDashboard() {
  return (
    <div style={{display:"flex"}}>
      {/* <Sidebar/> */}
      <Dashboard/>
    </div>
  );
}

export default MainDashboard;